module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Text/Redo-62a0341dd4a4fff1c9165125c16c2eb89b7297bada9996402ebeceda2d5ffff2.svg";